export default __webpack_public_path__ + "static/media/instapay.3b8cda04.png";